import images from './images';

const wines = [
  {
    title: 'Chapel Hill Shiraz',
    price: '$56',
    tags: 'AU | Bottle',
  },
  {
    title: 'Catena Malbee',
    price: '$59',
    tags: 'AU | Bottle',
  },
  {
    title: 'La Vieillw Rose',
    price: '$44',
    tags: 'FR | 750 ml',
  },
  {
    title: 'Rhino Pale Ale',
    price: '$31',
    tags: 'CA | 750 ml',
  },
  {
    title: 'Irish Guinness',
    price: '$26',
    tags: 'IE | 750 ml',
  },
];

const cocktails = [
  {
    title: 'Aperol Sprtiz',
    price: '$20',
    tags: 'Aperol | Villa Marchesi prosecco | soda | 30 ml',
  },
  {
    title: "Dark 'N' Stormy",
    price: '$16',
    tags: 'Dark rum | Ginger beer | Slice of lime',
  },
  {
    title: 'Daiquiri',
    price: '$10',
    tags: 'Rum | Citrus juice | Sugar',
  },
  {
    title: 'Old Fashioned',
    price: '$31',
    tags: 'Bourbon | Brown sugar | Angostura Bitters',
  },
  {
    title: 'Negroni',
    price: '$26',
    tags: 'Gin | Sweet Vermouth | Campari | Orange garnish',
  },
];

const awards = [
  {
    imgUrl: images.award02,
    title: 'Bib Gourmond',
    subtitle: 'Lorem ipsum dolor sit amet, consectetur.',
  },
  {
    imgUrl: images.award01,
    title: 'Rising Star',
    subtitle: 'Lorem ipsum dolor sit amet, consectetur.',
  },
  {
    imgUrl: images.award05,
    title: 'AA Hospitality',
    subtitle: 'Lorem ipsum dolor sit amet, consectetur.',
  },
  {
    imgUrl: images.award03,
    title: 'Outstanding Chef',
    subtitle: 'Lorem ipsum dolor sit amet, consectetur.',
  },
];

const galeria = [
  {
    imgUrl: images.gallery_01,
    url: 'https://www.instagram.com/p/CZpBPVol2xH/',
  },
  {
    imgUrl: images.gallery_02,
    url: 'https://www.instagram.com/p/CWLmPZZll2E/',
  },
  {
    imgUrl: images.gallery_03,
    url: 'https://www.instagram.com/p/CVAvzusljo7/',
  },
  {
    imgUrl: images.gallery_04,
    url: 'https://www.instagram.com/p/CSHTmIgH4CA/',
  },
  {
    imgUrl: images.gallery_05,
    url: 'https://www.instagram.com/p/CRT5od7niXt/',
  },
  {
    imgUrl: images.gallery_06,
    url: 'https://www.instagram.com/p/CONdjTUHevf/',
  },
  {
    imgUrl: images.gallery_07,
    url: 'https://www.instagram.com/p/CODfQqsn-68/',
  },
  
];

const galleryPage = [
  {
    imgUrl: images.gallery_image_01
  },
  {
    imgUrl: images.gallery_image_02
  },
  {
    imgUrl: images.gallery_image_03
  },
  {
    imgUrl: images.gallery_image_04
  },
  {
    imgUrl: images.gallery_image_05
  },
  {
    imgUrl: images.gallery_image_06
  },
  {
    imgUrl: images.gallery_image_07
  },
  {
    imgUrl: images.gallery_image_08
  },
  {
    imgUrl: images.gallery_image_09
  },
  {
    imgUrl: images.gallery_image_10
  },
  {
    imgUrl: images.gallery_image_11
  },
  {
    imgUrl: images.gallery_image_12
  },
  {
    imgUrl: images.gallery_image_13
  },
  {
    imgUrl: images.gallery_image_14
  },
  {
    imgUrl: images.gallery_image_15
  },
  {
    imgUrl: images.gallery_image_16
  },
  {
    imgUrl: images.gallery_image_17
  },
  {
    imgUrl: images.gallery_image_18
  },
  {
    imgUrl: images.gallery_image_19
  },
  {
    imgUrl: images.gallery_image_20
  }

]

const data = { wines, cocktails, awards, galeria, galleryPage };

export default data;
